<template>
  <div id="update_batch_status">
    <vs-popup id="update_batch_status__modal" title="Update Batch Status" :style="{ 'z-index': zIndex }" :active.sync="isActive">
      <div class="vx-row">
        <div class="mb-2 vx-col w-full">
          <!-- batch status Dropdown -->
          <div class="mb-2 w-full">
            <label for="status">Batch Status</label>
            <select-2
              class="w-full"
              :value="status"
              @input="item => (status = item && item.value)"
              label-placeholder="Status"
              name="Status"
              placeholder="Select Status"
              :options="BatchStatus"
              v-validate="'required'"
            />
          </div>
        </div>
      </div>

      <!-- action btn -->
      <div class="vx-row justify-center">
        <vs-button class="mr-5" color="primary" type="relief" @click="save_changes">Save</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { BatchStatus } from '@/utils/enums'
import { backgrondScrollHandler } from '@/utils/functions'

export default {
  name: 'BatchStatusUpdate',

  components: {
    Select2,
    Datepicker
  },

  props: {
    isModalShow: Boolean,
    batch: Object
  },

  data() {
    return {
      loading: false,
      zIndex: 0,
      BatchStatus,
      status: null
    }
  },

  mounted() {
    // handle backgrond scroll
    backgrondScrollHandler(true)

    // set modal zindex
    this.SET_MODAL_ZINDEX(true)

    // set z index
    this.zIndex = this.modal.modalZIndex + this.modal.modalOpens + 1

    // initial status
    this.status = this.batch.status
  },

  computed: {
    ...mapState(['modal']),

    isActive: {
      get() {
        return this.isModalShow
      },

      set(val) {
        if (!val) {
          // handle backgrond scroll
          backgrondScrollHandler(false)
          // set modal zindex
          this.SET_MODAL_ZINDEX(false)
        }

        this.$emit('update:isModalShow', val)
      }
    }
  },

  methods: {
    ...mapMutations(['SET_MODAL_ZINDEX']),

    // update batch status - confirmation
    async save_changes() {
      if (!(await this.$validator.validate())) {
        return false
      }

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Are you sure?',
        text: `${
          this.status === 'inactive'
            ? 'Changing  the batch status to "inactive" will move the batch to the Inactive Batch List'
            : 'Changing the batch status to "active" will move the batch to the Active Batches.'
        } 
        Are you sure you want to save this record?`,
        acceptText: 'Yes, I am sure!',
        cancelText: 'No, cancel it!',
        accept: await this.updateBatchStatus
      })
    },

    // update batch status - submit
    async updateBatchStatus() {
      this.loading = true
      this.$store
        .dispatch('batch/updateStatus', { id: this.batch.id, payload: { batch_status: this.status, status_type: 'status' } })
        .then(({ message }) => {
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.$emit('done')
          this.isActive = false
        })
        .catch(({ message }) => {
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#update_batch_status__modal .vs-popup .vs-popup--content',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#update_batch_status__modal .vs-popup .vs-popup--content > .con-vs-loading')
      }
    }
  }
}
</script>

<style lang="scss">
#update_batch_status__modal {
  .vs-popup {
    position: relative;

    .con-vs-loading {
      position: absolute;
    }

    .vdp-datepicker {
      position: unset;
    }
  }
}
</style>
